export default "__VITE_PUBLIC_ASSET__06cf13d8__"